require('../modules/web.dom.iterable');
require('../modules/es6.string.iterator');
module.exports = require('../modules/core.is-iterable');



//////////////////
// WEBPACK FOOTER
// ./node_modules/.2.5.7@core-js/library/fn/is-iterable.js
// module id = 596
// module chunks = 1